export default "__VITE_ASSET__4LoAtKNG__"